import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-98" data-mp="1mf2ctd0ek2u7">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-99" data-mp="1mgn9p9a6vxv8">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/15 text-brand-orange" data-id="element-100" data-mp="1hnakoy1llp1y">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-101" data-mp="1wf2z97tkiz2m" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-102" data-mp="1rddnfpyiuhdh">Cosa ricevi subito?</h2>
        <div className="space-y-3 text-left" data-id="element-103" data-mp="25d4xjflx3dm7">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-main p-5" data-id="element-104" data-mp="20f3dosgo3a9o">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-105" data-mp="612fm9sxyran" />
              <span className="font-semibold" data-id="element-106" data-mp="2n26wtaiwad1w">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-107" data-mp="2s08hfzvyykfh">
          Non resterai mai più senza materiale.
        </p>
      </Reveal>
    </section>;
}